import React, { history, useEffect, useState, useMemo } from "react";
import Quick_links from "../utility/Quick_links";
import Hiring from "./Jobs/Hiring";
import $, { parseJSON } from 'jquery';
import Services from "../services/services";
import { useNavigate, useParams } from "react-router-dom";
const EmailNotification = () => {
  const navigate = useNavigate();
  const [categories, setCategory] = useState([]);
  const companyId = sessionStorage.getItem("logCompanyId") || localStorage.getItem("logCompanyId");
  const emailAddress = sessionStorage.getItem("logEmail") || localStorage.getItem("logEmail");

  useEffect(() => {
    const jsonData = {
      "emailNotification": {

      }
    };
    var jsondataformatted = JSON.stringify(jsonData);
    sessionStorage.setItem('pagejsonObject', jsondataformatted);

    if (companyId == null || companyId == "null") {
      //navigate('/login');
      navigate('/Home');
    }

    getIndustryData();
    getSubscriptionTagsList();
    $("#successMessageSub").hide();


    $("#subscribeBtn").click(function () {
      subscribeAction();
    });

  }, []);


  const getSubscriptionTagsList = () => {

    var email_input = sessionStorage.getItem("appEmail") || localStorage.getItem("appEmail");
    const requestObject = {
      "listId": "0064626635",
      //"emailAddress": "testemail1employer@nexasi.com"
      "emailAddress": email_input

    };
    console.log(requestObject);
    var accessTokenIn = sessionStorage.getItem("accToken") || localStorage.getItem("accToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        //'Content-Type': 'application/javascript',
        'Authorization': "Bearer " + accessTokenIn,
        //'Authorization': accessTokenIn, 
        'data-type': 'jsonp',

      },
      body: JSON.stringify(requestObject)
    };

    Services.getProfileMemberSubscribeTags(requestOptions).then((res) => {
      var categoriesArray = [];
      //console.log("-->"+JSON.stringify(res));
      // if (res) {
      //   var tagsAr = res.tags;
      //   for (var i = 0; i < tagsAr.length; i++) {
      //     console.log(tagsAr[i].name);
      //     categoriesArray.push(tagsAr[i].name);
      //     var catName = tagsAr[i].name;
      //     $('input[name="category"][value="' + catName + '"]').prop("checked", true);
      //   }
      // }

      if (res && Array.isArray(res.tags)) {
        var tagsAr = res.tags;
        for (var i = 0; i < tagsAr.length; i++) {
          console.log(tagsAr[i].name);
          categoriesArray.push(tagsAr[i].name);
          var catName = tagsAr[i].name;
          $('input[name="category"][value="' + catName + '"]').prop("checked", true);
        }
      } else {
        console.warn("Tags not found in response", res);
      }
      //navigate('/thankyou');

    });


  }


  const getIndustryData = () => {
    Services.getIndustryData().then((res) => {
      console.log("Industry data=" + JSON.stringify(res.data));
      setCategory(res.data.content);
    });
  }

  const subscribeAction = () => {


    var catofExpertiseArrayUnsub = [];
    var pTrimcatofExpertiseArray = [];

    /*
    for(var i=0;i<categories.length;i++){
      var tn = {};
      tn.name = "Profile - "+categories[i].name;
      
      tn.status = "inactive";  
      catofExpertiseArrayUnsub.push(tn);
    }
    */

    $.each($("input[name='category']"), function () {
      var tn = {};
      tn.name = $(this).val();
      tn.status = "inactive";
      //catofExpertiseArray.push($(this).val());
      catofExpertiseArrayUnsub.push(tn);

       var tn2 = {};
        //tn2.name = $(this).val();
        tn2.name = $(this).val().replace("Profile-", "");
        tn2.status = "inactive";
        //catofExpertiseArray.push($(this).val());
        pTrimcatofExpertiseArray.push(tn2);
    });


    console.log(JSON.stringify(categories));
    console.log(JSON.stringify(catofExpertiseArrayUnsub));
    console.log("#########86$$");




     const categoryMergeFieldMap = {
        "Accounting": "accounting",
        "Advanced Manufacturing (Robotics, Welding, CNC)": "adv_mfg",
        "Advertising and PR Services": "adv_pr",
        "Agriculture and Food Processing": "agri_food",
        "Architectural and Design Services": "arc_design",
        "Art": "art",
        "Athletic Training/Physical/Occupational Therapy": "athletic",
        "Auto/Diesel Technology": "auto_diesel",
        "Banking/Financial Management": "banking",
        "Business and Administrative Services": "business",
        "Computer Networking/Network Security": "comp_net",
        "Computer Programming/Web Programming": "comp_prog",
        "Construction Technologies": "const_tech",
        "Culinary Arts": "culinary",
        "Dental Hygiene": "dental",
        "Distribution/Warehousing": "dist_ware",
        "Education": "education",
        "Engineering and Science Technologies": "eng_sci",
        "Government, Law & Public Safety": "gov_law",
        "Graphic Design": "graphics",
        "Healthcare Services": "health_srv",
        "Hospitality and Tourism": "hosp_tour",
        "Human Resources": "hr",
        "Information Technology": "it",
        "IT": "infotech",
        "Insurance and Financial Services": "ins_fin",
        "Journalism": "journalism",
        "Manufacturing": "mfg",
        "Nursing": "nursing",
        "Pharmaceuticals": "pharma",
        "Printing and Publishing": "printing",
        "Professional Services": "prof_srv",
        "Psychology/Sociology": "psych_soc",
        "Radiographic Imaging (X-Ray/Ultrasound)": "imaging",
        "Real Estate/Property Management": "real_estat",
        "Respiratory Care": "resp_care",
        "Retail": "retail",
        "Sales and Marketing": "sales_mktg",
        "Skilled Trades/Maintenance": "skilled",
        "Social Work/Human Services": "soc_work",
        "Supply Chain Management": "supp_mgmt",
        "Telecommunications": "telecom",
        "Transportation and Logistics": "transport",
        "Veterinary Medicine": "vet_meds"
      };
      var dname = sessionStorage.getItem("displayName") || localStorage.getItem("displayName");
       // Start with name fields
      const mergeFields = {
        FNAME: dname,
        LNAME: ""
      };


       // Add only selected categories as TRUE (optional: mark others as FALSE)
      pTrimcatofExpertiseArray.forEach(function (selectedCat) {
        //alert(JSON.stringify(selectedCat));
        const mergeKey = categoryMergeFieldMap[selectedCat.name];
        //alert(mergeKey)
        if (mergeKey) {
          //mergeFields[mergeKey] = "TRUE";
          mergeFields[mergeKey.toUpperCase()] = "";
        }
      });
      
      var a_email = sessionStorage.getItem("appEmail") || localStorage.getItem("appEmail");
    const requestObjectUnsub = {

      //"email_address": "testemail1employer@nexasi.com",
      "email_address": a_email,
      /*
      "merge_fields": {
        "FNAME": "",
        "LNAME": ""
      },
      */
      "merge_fields": mergeFields,
      "tags": catofExpertiseArrayUnsub

    }

    var accessTokenIn = sessionStorage.getItem("accToken") || localStorage.getItem("accToken");
    const requestOptionsUnsub = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'data-type': 'jsonp',
        'Authorization': "Bearer " + accessTokenIn
      },
      body: JSON.stringify(requestObjectUnsub)
    };

    Services.profileMemberSubscribeTags(requestOptionsUnsub).then((res) => {
      //navigate('/thankyou');    
      ///#################################################


      var catofExpertiseArray = [];
      var pTrimcatofExpertiseArray = [];
      $.each($("input[name='category']:checked"), function () {
        var tn = {};
        tn.name = $(this).val();
        tn.status = "active";
        //catofExpertiseArray.push($(this).val());
        catofExpertiseArray.push(tn);


        var tn2 = {};
        //tn2.name = $(this).val();
        tn2.name = $(this).val().replace("Profile-", "");
        tn2.status = "active";
        //catofExpertiseArray.push($(this).val());
        pTrimcatofExpertiseArray.push(tn2);

      });
      console.log("@@@pTrimcatofExpertiseArray");
      console.log(JSON.stringify(pTrimcatofExpertiseArray))

      //
      // Mapping: Category Name → Mailchimp Merge Field Key
      const categoryMergeFieldMap = {
        "Accounting": "accounting",
        "Advanced Manufacturing (Robotics, Welding, CNC)": "adv_mfg",
        "Advertising and PR Services": "adv_pr",
        "Agriculture and Food Processing": "agri_food",
        "Architectural and Design Services": "arc_design",
        "Art": "art",
        "Athletic Training/Physical/Occupational Therapy": "athletic",
        "Auto/Diesel Technology": "auto_diesel",
        "Banking/Financial Management": "banking",
        "Business and Administrative Services": "business",
        "Computer Networking/Network Security": "comp_net",
        "Computer Programming/Web Programming": "comp_prog",
        "Construction Technologies": "const_tech",
        "Culinary Arts": "culinary",
        "Dental Hygiene": "dental",
        "Distribution/Warehousing": "dist_ware",
        "Education": "education",
        "Engineering and Science Technologies": "eng_sci",
        "Government, Law & Public Safety": "gov_law",
        "Graphic Design": "graphics",
        "Healthcare Services": "health_srv",
        "Hospitality and Tourism": "hosp_tour",
        "Human Resources": "hr",
        "Information Technology": "it",
        "IT": "infotech",
        "Insurance and Financial Services": "ins_fin",
        "Journalism": "journalism",
        "Manufacturing": "mfg",
        "Nursing": "nursing",
        "Pharmaceuticals": "pharma",
        "Printing and Publishing": "printing",
        "Professional Services": "prof_srv",
        "Psychology/Sociology": "psych_soc",
        "Radiographic Imaging (X-Ray/Ultrasound)": "imaging",
        "Real Estate/Property Management": "real_estat",
        "Respiratory Care": "resp_care",
        "Retail": "retail",
        "Sales and Marketing": "sales_mktg",
        "Skilled Trades/Maintenance": "skilled",
        "Social Work/Human Services": "soc_work",
        "Supply Chain Management": "supp_mgmt",
        "Telecommunications": "telecom",
        "Transportation and Logistics": "transport",
        "Veterinary Medicine": "vet_meds"
      };

       // Start with name fields
      const mergeFields = {
        FNAME: sessionStorage.getItem("displayName"),
        LNAME: ""
      };

      // Add only selected categories as TRUE (optional: mark others as FALSE)
      pTrimcatofExpertiseArray.forEach(function (selectedCat) {
        //alert(JSON.stringify(selectedCat));
        const mergeKey = categoryMergeFieldMap[selectedCat.name];
        //alert(mergeKey)
        if (mergeKey) {
          //mergeFields[mergeKey] = "TRUE";
          mergeFields[mergeKey.toUpperCase()] = "TRUE";
        }
      });


      //
      console.log("@@231")


      //phone_val = "1234567899";
      const requestObject = {


        //"email_address": "testemail1employer@nexasi.com",
        "email_address": sessionStorage.getItem("appEmail"),
        /*
        "merge_fields": {
          "FNAME": sessionStorage.getItem("displayName"),
          "LNAME": " "
        },
        */
        "merge_fields": mergeFields,
        "tags": catofExpertiseArray

      }
      console.log(requestObject);
      var mailchimpAPIkey = "ff090a200b0502d7853365f13897bc77";
      var accessTokenIn = sessionStorage.getItem("accToken") || localStorage.getItem("accToken");
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          //'Content-Type': 'application/javascript',
          'data-type': 'jsonp',
          'Authorization': "Bearer " + accessTokenIn
          //'Authorization': accessTokenIn 
          //'Authorization': "apikey "+mailchimpAPIkey 
        },
        body: JSON.stringify(requestObject)
      };

      Services.profileMemberSubscribeTags(requestOptions).then((res) => {

        $("#successMessageSub").fadeTo(2000, 500).slideUp(500, function () {
          $("#successMessageSub").slideUp(500);
        });
        //navigate('/thankyou');

      });





      ///###################################################
    });








  }

  return (
    <>
      <main class="empr-directory-main">
        <div class="main-bgpatten"></div>
        {/* <!-- info typography -->  */}
        <section class="headtitle-wrap">
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <nav style={{ "--bs-breadcrumb-divider": "'>';" }} aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item headtitle "><a href="/companyJobs">Company Dashboard</a> </li>
                    <li class="breadcrumb-item headtitle "><a href="#">Subscribe to Resumes and Profiles</a></li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- info typography --> */}
        <section class="py-5">
          <div class="container">
            <div class="row">
              <div class="col-12 ">
                <div class="white-bg p-5">
                  <div class="row">
                    {/* <!-- left side --> */}
                    <Quick_links />

                    {/* <!-- right side --> */}
                    <div class="col-lg-8 mb-4">

                      <div class="p-3 border mb-3">
                        Select the job sectors relevant to your business . Based on your selection, you will receive a weekly email featuring job seekers who have expressed interest in those areas.
                      </div>

                      <b>Emails are sent to: {emailAddress}</b>

                      <div class="col-lg-12 my-3">
                        <div class="d-flex"><label for="firstName" class="form-label mr-2 mb-3">JOB SECTORS <span class="red-text">*</span></label></div>

                        <div >
                          <div class="category-check-itm">
                            <ul class="category-check">
                              {
                                categories.map((data, index) => (


                                  <li><input class="form-check-input" type="checkbox" name="category" value={"Profile-" + data.name} id="defaultCheck1" />  <label class="form-check-label" for="defaultCheck1"> {data.name} </label></li>

                                ))}
                              {/* <li><input class="form-check-input" type="checkbox" value="" id="defaultCheck1"/> <label class="form-check-label" for="defaultCheck1"> Accounting </label></li>
                                                    <li><input class="form-check-input" type="checkbox" value="" id="defaultCheck1"/> <label class="form-check-label" for="defaultCheck1"> Advanced Manufacturing</label></li>
                                                    <li><input class="form-check-input" type="checkbox" value="" id="defaultCheck1"/> <label class="form-check-label" for="defaultCheck1"> Robotics </label></li>
                                                    <li><input class="form-check-input" type="checkbox" value="" id="defaultCheck1"/> <label class="form-check-label" for="defaultCheck1"> CNC  </label></li>
                                                    <li><input class="form-check-input" type="checkbox" value="" id="defaultCheck1"/> <label class="form-check-label" for="defaultCheck1"> Advertising and PR Services  </label></li>
                                                    <li><input class="form-check-input" type="checkbox" value="" id="defaultCheck1"/> <label class="form-check-label" for="defaultCheck1"> Agriculture and Food Processing  </label></li>
                                                    <li><input class="form-check-input" type="checkbox" value="" id="defaultCheck1"/> <label class="form-check-label" for="defaultCheck1"> Architectural and Design Services  </label></li>
                                                    <li><input class="form-check-input" type="checkbox" value="" id="defaultCheck1"/> <label class="form-check-label" for="defaultCheck1"> Art Athletic Training/Physical/ </label></li>
                                                    <li><input class="form-check-input" type="checkbox" value="" id="defaultCheck1"/> <label class="form-check-label" for="defaultCheck1"> Art Athletic Training/Physical/ </label></li>
                                                    <li><input class="form-check-input" type="checkbox" value="" id="defaultCheck1"/> <label class="form-check-label" for="defaultCheck1"> Occupational Therapy  </label></li>
                                                    <li><input class="form-check-input" type="checkbox" value="" id="defaultCheck1"/> <label class="form-check-label" for="defaultCheck1"> Auto/Diesel </label></li> */}
                            </ul>
                          </div>
                          {/* <div class="category-check-itm">
                                                <ul>
                                                    <li><input class="form-check-input" type="checkbox" value="" id="defaultCheck1"/> <label class="form-check-label" for="defaultCheck1"> Accounting </label></li>
                                                    <li><input class="form-check-input" type="checkbox" value="" id="defaultCheck1"/> <label class="form-check-label" for="defaultCheck1"> Advanced Manufacturing</label></li>
                                                    <li><input class="form-check-input" type="checkbox" value="" id="defaultCheck1"/> <label class="form-check-label" for="defaultCheck1"> Robotics </label></li>
                                                    <li><input class="form-check-input" type="checkbox" value="" id="defaultCheck1"/> <label class="form-check-label" for="defaultCheck1"> CNC  </label></li>
                                                    <li><input class="form-check-input" type="checkbox" value="" id="defaultCheck1"/> <label class="form-check-label" for="defaultCheck1"> Advertising and PR Services  </label></li>
                                                    <li><input class="form-check-input" type="checkbox" value="" id="defaultCheck1"/> <label class="form-check-label" for="defaultCheck1"> Agriculture and Food Processing  </label></li>
                                                    <li><input class="form-check-input" type="checkbox" value="" id="defaultCheck1"/> <label class="form-check-label" for="defaultCheck1"> Architectural and Design Services  </label></li>
                                                    <li><input class="form-check-input" type="checkbox" value="" id="defaultCheck1"/> <label class="form-check-label" for="defaultCheck1"> Art Athletic Training/Physical/ </label></li>
                                                    <li><input class="form-check-input" type="checkbox" value="" id="defaultCheck1"/> <label class="form-check-label" for="defaultCheck1"> Art Athletic Training/Physical/ </label></li>
                                                    <li><input class="form-check-input" type="checkbox" value="" id="defaultCheck1"/> <label class="form-check-label" for="defaultCheck1"> Occupational Therapy  </label></li>
                                                    <li><input class="form-check-input" type="checkbox" value="" id="defaultCheck1"/> <label class="form-check-label" for="defaultCheck1"> Auto/Diesel </label></li>
                                                </ul>
                                            </div> */}

                        </div>

                        <div class="d-flex justify-content-between align-items-end choose mt-3">
                          <div><a id="subscribeBtn" class="reg-button">Subscribe</a></div>
                        </div>
                        <br></br>
                        <div id="successMessageSub" class="alert alert-success" role="alert">
                          Subscription details updated</div>

                      </div>

                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </section>
        {/* <Hiring/> */}
      </main>
    </>
  )
};

EmailNotification.propTypes = {};

EmailNotification.defaultProps = {};

export default EmailNotification;
